module.exports = __webpack_public_path__ + "static/ac_observable-df3c2339851fb36df8b75aa956c9e374.png";